import Button from '@rio-cloud/rio-uikit/Button';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import { useIntl } from 'react-intl';

import type { Document as DocumentModel, Documents as DocumentsList } from '#domain/Document.ts';

import { Document as DocumentItem } from './Document.tsx';

type DocumentsProps = {
    label?: string;
    buttonTitle?: string;
    className?: string;
    documents?: DocumentsList;
    onDocPress: (doc: DocumentModel) => void;
    uploadDocument?: () => void;
    uploadButtonTrackingKey?: string;
};

const documentOriginOrder = {
    driver: 0,
    dispatcher: 1,
    unknown: 2,
} as const;

export const DocumentsCategory = ({
    label,
    buttonTitle,
    className = '',
    documents = [],
    onDocPress,
    uploadDocument,
    uploadButtonTrackingKey,
}: DocumentsProps) => {
    const intl = useIntl();
    const sortedDocuments = [...documents].sort(
        (first, second) => documentOriginOrder[first.origin] - documentOriginOrder[second.origin]
    );

    return (
        <div className={className}>
            {label && (
                <div className='display-flex padding-bottom-5'>
                    <FormLabel className='margin-bottom-0'>{label}</FormLabel>
                </div>
            )}
            <div className='display-flex flex-column gap-10'>
                {sortedDocuments.map((item, index) => {
                    const origin = item.origin;
                    const previousOrigin = sortedDocuments[index - 1]?.origin;
                    const startsNewOrigin = index > 0 && origin !== previousOrigin;

                    return (
                        <div
                            key={item.id}
                            className={startsNewOrigin ? 'margin-top-10' : undefined}
                            data-document-origin={origin}
                        >
                            <DocumentItem doc={item} onDocPress={onDocPress} />
                        </div>
                    );
                })}
                {uploadDocument !== undefined && (
                    <Button
                        bsStyle='default'
                        iconName='rioglyph-upload'
                        iconRight
                        autoTrackingKey={uploadButtonTrackingKey ?? 'ordercom.documents.category.upload'}
                        className='border-style-dashed border-color-light hover-bg-lightest hover-text-color-primary'
                        onClick={uploadDocument}
                    >
                        {buttonTitle ??
                            intl.formatMessage({
                                id: 'intl-msg:ordercom-cloud-frontend.common.documents.upload',
                                defaultMessage: 'Upload documents',
                            })}
                    </Button>
                )}
            </div>
        </div>
    );
};
